/*
 * "Read more" / "What's in the box" disclosure.
 *
 * Delegated from the document so triggers keep working after a section
 * re-renders (Dawn replaces the product-info markup on every variant change,
 * which used to leave the freshly rendered button unbound and dead).
 *
 * Toggles rather than opening one-way: the trigger stays in place so the
 * shopper can close the panel again.
 */
document.addEventListener("click", (event) => {
  const trigger = event.target.closest?.(".show-more");
  if (!trigger) return;

  const controlledId = trigger.getAttribute("aria-controls");
  const controlledContent = controlledId ? document.getElementById(controlledId) : null;
  const siblingContent = trigger.nextElementSibling?.classList.contains("read-more-wrapper")
    ? trigger.nextElementSibling
    : null;
  const containerContent = trigger.closest("[data-read-more]")?.querySelector(".read-more-wrapper") || null;
  const content = controlledContent || siblingContent || containerContent;

  if (!content) return;

  const isOpen = !content.classList.contains("is-open");
  content.classList.toggle("is-open", isOpen);
  content.hidden = !isOpen;
  trigger.setAttribute("aria-expanded", String(isOpen));
});
